<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        회사검색
    </h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-auto">
            <div class="input-group input-group-sm">
                <input type="text" class="form-control" placeholder="검색어"
                    [(ngModel)]="searchValue"
                    (keyup.enter)="keyupEnterSearchValue($event)">
                <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary"
                        (click)="clickSearch()">
                        <i class="fas fa-search"></i>
                        <span class="ml-1">
                            검색
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="col"></div>
    </div>

    <div class="table-responsive mt-3">
        <table class="table table-sm table-hover align-items-center mb-0">
            <thead class="">
                <tr>
                    <th>
                        회사이름
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngIf="listItems">
                <tr *ngFor="let item of listItems;">
                    <td>
                        <button type="button"
                            class="btn btn-link btn-block text-decoration-none text-left text-cyan text-nowrap"
                            (click)="clickSelectCompany(item)">
                            {{item.companyNm}}
                        </button>
                    </td>
                </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <div class="mt-3">
        <list-paging
            [inputPagingInfo]="pagingInfo"
            (callbackClickPageNumber)="callbackClickPageNumber($event)"
            (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
    </div>
</div>

<div class="modal-footer">
    <!-- <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            확인
        </span>
    </button> -->
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()"
        ngbAutofocus>
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            취소
        </span>
    </button>
</div>